import React, { Component } from 'react';
import {
    Link,
    Redirect,
    RouteProps
} from 'react-router-dom';
import {
    MediaStore
} from '../store';

export interface PropsFromState {
    mediaStore: MediaStore
}

export interface PropsFromDispatch {
    addMediaToPost: (mediaURL: string) => void
}

class ComposerMediaPreview extends Component<
    RouteProps &
    PropsFromState &
    PropsFromDispatch, any> {

    constructor(props: PropsFromState & PropsFromDispatch) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        this.props.addMediaToPost(formData.get("mediaURL") as string);
    }

    render() {

        const {
        } = this.props;
        const imgProxy = "http://165.227.131.254:8080/560x/"

        const mediaURL = this.props.location && this.props.location.pathname.replace("/composer/media/preview/", "")
        console.log("mediaURL:: ", mediaURL)
        if (!mediaURL) {
            return (
                <div>Oh noes! no couldnt find any media</div>
            )
        }

        const mediaItem = this.props.mediaStore[mediaURL]
        if (!mediaItem) {
            return (
                <div>Oh noes! no couldnt find any media</div>
            )
        }
        console.log("mediaItem:: ", mediaItem)

        const mediaImg = imgProxy + mediaItem.url;
        const mediaDateTime = mediaItem.datetime

        return (
            <div>
                <h1>Add Media</h1>

                <nav className="tc mv1 center">
                    <Link
                        className="f6 f5-l link black b bg-lightest-blue dib pa3"
                        to="/composer/media/gallery">
                        Gallery
                    </Link>
                    <a className="f6 f5-l link black-80 hover-bg-lightest-blue dib pa3" href="#" title="Home">Device</a>
                </nav>

                <article
                    className="">
                    <div className="tc">
                        <img src={mediaImg} />
                    </div>
                    <span className="db">{mediaDateTime}</span>
                </article>

                <form onSubmit={this.handleSubmit}>
                    <input
                    name="mediaURL"
                        type="hidden"
                        value={mediaItem.url}
                    />

                    <input
                        type="submit"
                        value="Add to Post"
                        className="input-reset pa2 w-100 mt1"
                    />

                </form>
            </div>
        );
    }
}

export default ComposerMediaPreview;
